import { Magnetic } from "../../styles";
import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
export const StyledCircularProgressContainer = styled(Grid) `
	height: 100%;
	position: relative;
`;
export const StyledCircularProgressColor = styled('div', {
    shouldForwardProp: prop => prop !== 'hasPercentageLabel'
})((props) => `
	color: ${props.hasPercentageLabel ? Magnetic.colorGreen03 : Magnetic.colorUltrablue50};
`);
export const StyledCircularProgressLabel = styled('div', {
    shouldForwardProp: prop => prop !== 'hasPercentageLabel'
})((props) => `
	color: ${Magnetic.colorNeutral60};
	font-size: ${props.hasPercentageLabel ? Magnetic.fontSize08 : Magnetic.fontSize24};
	position: ${props.hasPercentageLabel ? 'absolute' : null};
	margin-left: ${props.hasPercentageLabel ? '0' : Magnetic.spacer08};
`);
//# sourceMappingURL=Style.js.map